<template>
  <aside class="education-assistant" :class="{ 'is-collapsed': collapsed }">
    <header class="assistant-header">
      <div v-if="!collapsed" class="assistant-title">
        <span><Icon icon="ep:magic-stick" :size="18" /></span>
        <div><strong>上下文 AI 助手</strong><small>AI 生成内容需人工复核</small></div>
      </div>
      <button
        type="button"
        :aria-label="collapsed ? '展开 AI 助手' : '收起 AI 助手'"
        @click="$emit('toggle')"
      >
        <Icon :icon="collapsed ? 'ep:arrow-left' : 'ep:arrow-right'" :size="18" />
      </button>
    </header>

    <template v-if="!collapsed">
      <div class="assistant-body">
        <div class="assistant-empty">
          <Icon icon="ep:chat-dot-round" :size="28" />
          <strong>等待页面上下文</strong>
          <span>进入具体教学页面后，可基于当前课程、班级或任务发起辅助操作。</span>
        </div>
      </div>
      <footer class="assistant-composer">
        <el-input type="textarea" :rows="3" disabled placeholder="当前页面尚未接入 AI 上下文" />
        <el-button type="primary" disabled aria-label="发送"
          ><Icon icon="ep:promotion"
        /></el-button>
      </footer>
    </template>
  </aside>
</template>

<script setup lang="ts">
defineOptions({ name: 'AiEducationAssistant' })
defineProps<{ collapsed: boolean }>()
defineEmits<{ toggle: [] }>()
</script>

<style scoped>
.education-assistant {
  display: flex;
  min-width: 0;
  height: 100vh;
  flex-direction: column;
  overflow: hidden;
  border-left: 1px solid #e5e9ec;
  background: #fff;
}

.assistant-header {
  display: flex;
  height: 64px;
  flex: 0 0 64px;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px 0 16px;
  border-bottom: 1px solid #e5e9ec;
}

.assistant-title {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
}

.assistant-title > span {
  display: grid;
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  place-items: center;
  border-radius: 6px;
  color: #fff;
  background: #19705d;
}

.assistant-title div {
  display: flex;
  min-width: 0;
  flex-direction: column;
}

.assistant-title small {
  margin-top: 2px;
  color: #697681;
  font-size: 11px;
}

.assistant-header button {
  display: grid;
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  cursor: pointer;
  place-items: center;
  border: 0;
  border-radius: 6px;
  color: #697681;
  background: transparent;
}

.assistant-header button:hover {
  color: #19705d;
  background: #eef5f2;
}

.assistant-body {
  display: grid;
  min-height: 0;
  flex: 1;
  place-items: center;
  overflow: auto;
  padding: 20px;
}

.assistant-empty {
  display: flex;
  max-width: 240px;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  color: #697681;
  text-align: center;
}

.assistant-empty strong {
  color: #17222d;
}

.assistant-empty span {
  font-size: 13px;
  line-height: 1.7;
}

.assistant-composer {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 36px;
  align-items: end;
  gap: 8px;
  padding: 12px;
  border-top: 1px solid #e5e9ec;
}

.assistant-composer .el-button {
  width: 36px;
  margin: 0;
  padding: 0;
}

.is-collapsed .assistant-header {
  justify-content: center;
  padding: 0;
}
</style>
